/* eslint-disable no-useless-escape */
/* eslint-disable standard/no-callback-literal */
import { get, isEqual, uniqBy } from "lodash";
import md5 from "md5";
import moment from "moment";
import * as queryString from "query-string";
import * as MobileDetect from "react-device-detect";
import {
  AFTERNOON,
  ALL_DAY,
  CHOOSE_GENDER,
  CHOOSE_YEAR,
  COOKIE_VIETINBANK,
  FEMALE,
  IN_PROCESSING,
  listAppId,
  MALE,
  MORNING,
  NO,
  NOT_UPDATE,
  SERVICE_TYPE_INSURANCE,
  YES
} from "~/utils/constants";
import { getReplaceUTF8 } from "~/utils/getReplaceUTF8";
import AppId from "~/utils/partner";
import Cookies from "js-cookie";

export const getMedicalBillStatus = (code, bookingDate) => {
  switch (code) {
    case -1:
      return "Hủy thanh toán";
    case -2:
      return "Hủy không khám";
    case -3:
      return "Quá ngày khám";
    case 0:
      return "Chưa thanh toán";
    case 1:
      if (moment().diff(bookingDate, "day") > 0) return "Quá ngày khám";
      return "Chưa khám";
    case 2:
      return "Đã khám";
    default:
      return IN_PROCESSING;
  }
};

export const getTimeToCancelBookingByHospitalId = hospitalId => {
  switch (hospitalId) {
    case 2:
      return "16:30";
    case 3:
      return "15:30";
    case 4:
      return "15:30";
    case 5:
      return "15:00";
    case 6:
      return "16:30";
    case 7:
      return "16:30";
    default:
      return "15:00";
  }
};

export const convertVietnameseStyleFor = dayString => {
  const momentDay = moment(dayString);
  return momentDay.format("DD-MM-YYYY");
};

export const getGender = code => {
  switch (code) {
    case 0:
      return FEMALE;
    case 1:
      return MALE;
    default:
      return NOT_UPDATE;
  }
};

export const getGenders = () => {
  const placeHolder = { id: -1, name: CHOOSE_GENDER };
  const m = { id: 1, name: MALE };
  const f = { id: 0, name: FEMALE };
  const data = [placeHolder, m, f];
  return data;
};

export const getBirthYears = () => {
  const placeHolder = { id: 0, name: CHOOSE_YEAR };
  const birthYears = [placeHolder];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= 1900; i--) {
    const id = i;
    const name = i;
    const data = { id, name };
    birthYears.push(data);
  }
  return birthYears;
};

export const formatAmount = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const checkBHYT = code => {
  switch (code) {
    case 0:
      return NO;
    case 1:
      return YES;
    default:
      return NOT_UPDATE;
  }
};

export const getWorkingPeriod = code => {
  switch (code) {
    case 1:
      return MORNING;
    case 2:
      return AFTERNOON;
    case 3:
      return ALL_DAY;
    default:
      return "";
  }
};

export const setIsCookieVietinBank = () =>
  window.localStorage.setItem(COOKIE_VIETINBANK, true);
export const isCookieVietinBank = () =>
  window.localStorage.getItem(COOKIE_VIETINBANK) || false;

export const getFeesHistoryItemStatus = code => {
  switch (code) {
    case 0:
      return "Chưa thanh toán";
    case 1:
      return "Đã thanh toán";
    default:
      return NOT_UPDATE;
  }
};

export const validatePhoneNumber = number => {
  try {
    const ISD_CODES = [
      93,
      355,
      213,
      1684,
      376,
      244,
      1264,
      672,
      1268,
      54,
      374,
      297,
      61,
      43,
      994,
      1242,
      973,
      880,
      1246,
      375,
      32,
      501,
      229,
      1441,
      975,
      591,
      387,
      267,
      55,
      246,
      1284,
      673,
      359,
      226,
      257,
      855,
      237,
      1,
      238,
      1345,
      236,
      235,
      56,
      86,
      61,
      61,
      57,
      269,
      682,
      506,
      385,
      53,
      599,
      357,
      420,
      243,
      45,
      253,
      1767,
      1809,
      1829,
      1849,
      670,
      593,
      20,
      503,
      240,
      291,
      372,
      251,
      500,
      298,
      679,
      358,
      33,
      689,
      241,
      220,
      995,
      49,
      233,
      350,
      30,
      299,
      1473,
      1671,
      502,
      441481,
      224,
      245,
      592,
      509,
      504,
      852,
      36,
      354,
      91,
      62,
      98,
      964,
      353,
      441624,
      972,
      39,
      225,
      1876,
      81,
      441534,
      962,
      7,
      254,
      686,
      383,
      965,
      996,
      856,
      371,
      961,
      266,
      231,
      218,
      423,
      370,
      352,
      853,
      389,
      261,
      265,
      60,
      960,
      223,
      356,
      692,
      222,
      230,
      262,
      52,
      691,
      373,
      377,
      976,
      382,
      1664,
      212,
      258,
      95,
      264,
      674,
      977,
      31,
      599,
      687,
      64,
      505,
      227,
      234,
      683,
      850,
      1670,
      47,
      968,
      92,
      680,
      970,
      507,
      675,
      595,
      51,
      63,
      64,
      48,
      351,
      1787,
      1939,
      974,
      242,
      262,
      40,
      7,
      250,
      590,
      290,
      1869,
      1758,
      590,
      508,
      1784,
      685,
      378,
      239,
      966,
      221,
      381,
      248,
      232,
      65,
      1721,
      421,
      386,
      677,
      252,
      27,
      82,
      211,
      34,
      94,
      249,
      597,
      47,
      268,
      46,
      41,
      963,
      886,
      992,
      255,
      66,
      228,
      690,
      676,
      1868,
      216,
      90,
      993,
      1649,
      688,
      1340,
      256,
      380,
      971,
      44,
      1,
      598,
      998,
      678,
      379,
      58,
      84,
      681,
      212,
      967,
      260,
      263
    ];
    // extract numbers from string
    const thenum = number.match(/[0-9]+/g).join("");
    const totalnums = thenum.length;
    const ISDcode = thenum.substring(0, totalnums - 10);
    // phone numbers are generally of 8 to 16 digits
    if (totalnums >= 8 && totalnums <= 16) {
      if (ISDcode) {
        if (ISD_CODES.includes(parseInt(ISDcode))) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  } catch (e) {
    console.log("e :>> ", e);
  }
  return false;
};

window.Clipboard = ((window, document, navigator) => {
  var textArea, copy;

  // function isOS() {
  //   return navigator.userAgent.match(/ipad|iphone/i);
  // }

  function createTextArea(text) {
    textArea = document.createElement("textArea");
    textArea.value = text;
    textArea.setAttribute("readonly", true);
    document.body.appendChild(textArea);
  }

  function selectText() {
    // var range, selection;
    // if (isOS()) {
    //   range = document.createRange();
    //   range.selectNodeContents(textArea);
    //   selection = window.getSelection();
    //   selection.removeAllRanges();
    //   selection.addRange(range);
    //   textArea.setSelectionRange(0, 999999);
    // } else {
    //   textArea.select();
    // }
    textArea.select();
  }

  function copyToClipboard() {
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  copy = text => {
    createTextArea(text);
    selectText();
    copyToClipboard();
  };

  return {
    copy: copy
  };
})(window, document, navigator);

export const copyToClipboard = str => {
  window.Clipboard.copy(str);
};

export const formatDate = date => {
  return date.slice(8) + date.slice(4, 8) + date.slice(0, 4);
};

export const hash = phone => {
  if (phone.startsWith("+84")) {
    return md5(phone);
  }
  if (phone.startsWith("0")) {
    return md5("+84" + phone.slice(1, phone.length));
  }
  return md5("+84" + phone);
};

export const getDurationFromNowTo = (time = "") => {
  if (moment.duration(moment().diff(moment(time))).as("months") >= 1)
    return " " + moment(time).format("[ngày] DD [tháng] MM, YYYY");
  for (var unit of [
    ["weeks", "tuần"],
    ["days", "ngày"],
    ["hours", "giờ"],
    ["minutes", "phút"],
    ["seconds", "giây"]
  ]) {
    const duration = moment.duration(moment().diff(moment(time))).as(unit[0]);
    if (duration >= 1) {
      return ` ${Math.floor(duration).toString()} ${unit[1]} trước`;
    }
  }
  return ` 1 giây trước`;
};

export const convertNotiTitleIntoNotiType = (title = "") => {
  if (
    title.toLowerCase().includes("đăng ký") &&
    title.toLowerCase().includes("thành công")
  )
    return "Đặt khám thành công";

  if (title.toLowerCase().includes("hủy thành công"))
    return "Hủy phiếu thành công";
  if (
    title.toLowerCase().includes("thanh toán") &&
    title.toLowerCase().includes("thành công")
  )
    return "Thanh toán thành công";
};

export const createQueryString = (baseUrl, params) => {
  return queryString.stringifyUrl({
    url: baseUrl,
    query: params
  });
};

export const getStepFollowTreeMap = (subtype, partner) => {
  let preRoute = "";
  switch (subtype) {
    case "subject":
      preRoute = "/chon-chuyen-khoa";
      break;
    case "doctor":
      preRoute = "/chon-bac-si";
      break;
    case "service":
      preRoute = "/chon-dich-vu";
      break;
    case "room":
      preRoute = "/chon-phong-kham";
      break;
    case null: {
      preRoute = "/chon-lich-kham";
      break;
    }
    default:
      preRoute = "/chon-lich-kham";
  }
  return getRouteFollowPartnerId(preRoute, partner);
};

export const getRouteFollowPartnerId = (route, partner) => {
  if (listAppId.includes(AppId)) {
    return `/${partner}${route}`;
  }
  return route;
};

export const checkNodeInBookingTree = path => {
  const isHasSubject = path.includes("subject");
  const isHasService = path.includes("service");
  const isHasDoctor = path.includes("doctor");
  const isHasRoom = path.includes("room");
  return { isHasSubject, isHasService, isHasDoctor, isHasRoom };
};

export const getDescriptionFeePayment = status => {
  switch (status) {
    case 1:
      return "Đã thanh toán";
    case -1:
      return "Đã hủy";
    default:
      return "Chưa thanh toán";
  }
};

export const getResultScanQrCodeInsurance = (
  qrCodeMessage,
  callBackAfterScan
) => {
  const arrayinfoqr = qrCodeMessage.split("|");
  // console.log(arrayinfoqr.length);
  if (arrayinfoqr.length <= 10) {
  } else {
    const name = decodeURIComponent(
      arrayinfoqr[1].replace(/\s+/g, "").replace(/[0-9a-f]{2}/g, "%$&")
    );
    const address = decodeURIComponent(
      arrayinfoqr[4].replace(/\s+/g, "").replace(/[0-9a-f]{2}/g, "%$&")
    );
    const insuranceCode = arrayinfoqr[0];
    // let splitname = name.trim().split(" ");
    const birthdate = arrayinfoqr[2];
    // let sex = arrayinfoqr[3] - 1;

    callBackAfterScan({
      fullName: name,
      insuranceCode,
      birthdate,
      address
    });
  }
};

export const getPartnerFromURL = () => {
  const parseUrl = window.location.pathname.split("/", 3);
  return parseUrl.length === 3 ? parseUrl[1] : AppId;
};

export const getFilterList = (list, node) => {
  const array = [];

  list.forEach(i => {
    if (isEqual(node, "subject")) {
      i.detail.subjects.map(v => {
        return array.push({ [node]: v?.[node] });
      });
    }
  });

  const listRole = list.map(i => {
    if (i.detail[node]) {
      return { [node]: i.detail[node] };
    }
    return "";
  });

  return uniqBy(isEqual(node, "subject") ? array : listRole, node);
};

// {role: "TS", subject: "ABC", gender: 1, name: "dat"}
export const filterListByParams = (list, params) => {
  let filterList;
  filterList = list.filter(item => {
    const regex = new RegExp(getReplaceUTF8(params.name), "i");

    return getReplaceUTF8(item?.detail?.name).match(regex);
  });
  if (params.role.toLowerCase() !== "Học hàm / học vị".toLowerCase()) {
    filterList = filterList.filter(item => item.detail.role === params.role);
  }
  if (params.subject.toLowerCase() !== "Chuyên khoa".toLowerCase()) {
    filterList = filterList.filter(item =>
      item.detail.subjects.find(i => i.subject === params.subject)
    );
  }
  if (params.gender !== -1) {
    filterList = filterList.filter(item => {
      return item.detail.gender === params.gender;
    });
  }
  return filterList;
};

export const checkDevice = () => {
  return MobileDetect.isMobile || MobileDetect.isTablet;
};

export const checkOS = () => {
  let os = null;
  if (MobileDetect.isAndroid) os = true;
  if (MobileDetect.isIOS) os = false;
  return os;
};

export const getPartnerFromUrl = url => {
  let currentPartner = AppId;

  const array = url.split("/");
  if (array.length === 3 && !array[1].includes("-")) {
    currentPartner = array[1];
  }
  return currentPartner;
};

export const routerByPartnerId = (route, partner) => {
  if (listAppId.includes(AppId)) {
    return `/${partner}${route}`;
  }
  return route;
};

export const getNextStepViewNoti = noti => {
  const transId = get(noti, "eventData.transactionId", "");
  const typePaymentNoti = get(noti, "topicId", null);
  let url = "";
  switch (typePaymentNoti) {
    case "bookings.confirm":
    case "his.confirm":
    case "bookings.cancel":
    case "bookings.reminder": {
      url = `/phieu-kham-benh/chi-tiet/${transId}`;
      break;
    }
    case "invoice.confirm": {
      url = get(noti, "eventData.invoiceUrl");
      break;
    }
    case "payment": {
      break;
    }
    default:
      url = "/";
      break;
  }
  return url;
};

// prepare data for reserve
export const getDataToReserve = (
  totalDataReducer,
  globalReducer,
  paymentReducer,
  patientReducer,
  followUpReducer,
  bookingReducer
) => {
  const prevPartnerId = window.localStorage.getItem("prevPartnerId");

  const filterCheckData = get(totalDataReducer, "filterCheckData", []);
  const addonServices = get(totalDataReducer, "addonServices", []);
  const platformType = get(globalReducer, "device.type");

  const partnerid = get(totalDataReducer, "partnerId", "");
  const treeId = get(totalDataReducer, "treeId", "");

  const bookingInfo = totalDataReducer.schedulesSelected[0];
  const serviceId = get(bookingInfo, "service.id", "");
  const subjectId = get(bookingInfo, "subject.id", "");
  const doctorId = get(bookingInfo, "doctor.id", "");
  const roomId = get(bookingInfo, "room.id", "");

  const date = get(bookingInfo, "date", 0);
  const formatDate = moment(date).format("YYYY-MM-DD");
  const startTime = get(bookingInfo, "time.startTime", "");
  const endTime = get(bookingInfo, "time.endTime", "");
  const timeSlotId = get(bookingInfo, "time.timeId", "");
  const maxSlot = get(bookingInfo, "time.maxSlot", "");
  const availableSlot = get(bookingInfo, "time.availableSlot", "");

  const dateString = moment(formatDate + " " + startTime).toISOString() || "";
  const startTimeString =
    formatDate && startTime
      ? moment
          .utc(`${formatDate} ${startTime}`, "YYYY-MM-DD HH:mm")
          .utcOffset(7, true)
          .toISOString() || ""
      : "";
  const endTimeString =
    formatDate && endTime
      ? moment
          .utc(`${formatDate} ${endTime}`, "YYYY-MM-DD HH:mm")
          .utcOffset(7, true)
          .toISOString() || ""
      : "";

  const gatewayId = get(paymentReducer, "methodId", "NO_PAYMENT");
  const methodId = get(paymentReducer, "methodId", "NO_PAYMENT");
  const amount = get(paymentReducer, "price.grandTotal", 0);
  const subTotal = get(paymentReducer, "price.subTotal", 0);
  const totalFee = get(paymentReducer, "price.totalFee", 0);
  const paidService = get(paymentReducer, "price.paidService", true);
  const paymentTypeDetail = get(
    paymentReducer,
    "selectedMethod.code",
    "NO_PAYMENT"
  );
  const xcInfo =
    prevPartnerId !== partnerid ? "" : get(patientReducer, "patientXNC");

  const patientId = get(patientReducer, "selectedPatientId", "");
  const insuranceCode = get(patientReducer, "selectedPatient.insuranceCode");

  const serviceType = get(totalDataReducer, "service.serviceType");

  const insuranceChoice = get(
    totalDataReducer,
    "service.insuranceChoice.insurance"
  );

  const idReExam = get(followUpReducer, "idReExam", "");
  const secretBooking = window.localStorage.getItem("secretBooking");

  const addonMedproCare = get(bookingReducer, "addonMedproCare", "");
  const healthIndex = get(totalDataReducer, "healthIndex", {});

  return {
    secretBooking,
    treeId,
    amount,
    subTotal,
    totalFee,
    gatewayId,
    methodId,
    paidService,
    // redirectUrl,
    paymentTypeDetail,
    patientId,
    serviceId,
    subjectId,
    roomId,
    doctorId,
    startTimeString: startTimeString,
    startTime: startTimeString,
    endTime: endTimeString,
    bookingSlotId: dateString !== "" ? `${timeSlotId}_${partnerid}` : "",
    platform: platformType === "desktop" ? "pc" : "web",
    maxSlot,
    availableSlot,
    insuranceCode,
    hasInsuranceCode: serviceType === SERVICE_TYPE_INSURANCE,
    insuranceChoice,
    idReExam,
    filterCheckData,
    addonServices: addonServices?.map(i => i.id) || [],
    xcInfo,
    medproCareServiceIds: addonMedproCare ? [addonMedproCare?.id] : [],
    ...(healthIndex.height && healthIndex.weight
      ? { healthIndex: { height: Number(healthIndex.height), weight: Number(healthIndex.weight) } }
      : {})
  };
};
export const getDataToReserveRePayment = (
  selectedBill,
  globalReducer,
  paymentReducer
) => {
  const platformType = get(globalReducer, "device.type");
  const id = get(selectedBill, "bookingInfo.id");

  const gatewayId = get(paymentReducer, "methodId", "NO_PAYMENT");
  const methodId = get(paymentReducer, "methodId", "NO_PAYMENT");
  const paymentTypeDetail = get(
    paymentReducer,
    "selectedMethod.code",
    "NO_PAYMENT"
  );
  const groupId = 4;
  return {
    id,
    gatewayId,
    methodId,
    groupId,
    paymentTypeDetail,
    platform: platformType === "desktop" ? "pc" : "web"
  };
};

// resolve the path in object
export const pathResolve = (path, obj) => {
  if (!path) return null;
  return path.split(".").reduce((prev, curr) => {
    return prev ? prev[curr] : null;
  }, obj);
};

// transform data if needed
export const dataTransform = (data, transformType, altData) => {
  switch (transformType) {
    case "reformat-date":
      return moment(data, "YYYY-MM-DD").isValid()
        ? moment(data, "YYYY-MM-DD").format("DD/MM/YYYY")
        : altData[0];
    case "date-time":
      return moment(data).format("hh:mm DD/MM/YYYY");
    case "date":
      return moment(data).format("DD/MM/YYYY");
    case "gender":
      return data === 1 ? "Nam" : "Nữ";

    default:
      return data;
  }
};

export const appointmentDate = bookingInfo => {
  const date = get(bookingInfo, "date", "");
  const waitingConfirmDate = get(bookingInfo, "waitingConfirmDate", "");
  const dateStr = get(bookingInfo, "dateStr", "");

  const dates = date
    ? moment(date)
        .utcOffset(7)
        .format("HH:mm DD/MM/YYYY")
    : waitingConfirmDate;

  return dateStr || dates;
};
export const populateTransformViaCriteria = (
  object,
  criterias,
  ifTrue,
  ifFalse
) => {
  let result = ifFalse;
  criterias.forEach(criteria => {
    const val = dataTransform(
      pathResolve(criteria.dataindex, object),
      "default",
      pathResolve(criteria.altDataIndex, object)
    );
    if (val === criteria.value) return (result = ifTrue);
  });
  return result;
};

export const listTransformer = (list, options) => {
  if (!list) {
    return null;
  }

  const transformedList = list;
  options.forEach(option => {
    switch (option.type) {
      case "filter":
        return transformedList.filter();

      default:
        return transformedList;
    }
  });
  // loop through Filter Options and Filter the list
  return transformedList;
};

// export const restructuringListViaColumns = (list, columns) => {
//   //check if List is valid
//   if (!list || list === []) {
//     return [];
//   }
//   // console.log(list);
//   let reStructuredList = [];
//   list.forEach((item, index) => {
//     // item = 1 rows
//     // loop through columns and find match elements
//     const structuredItem = {};
//     structuredItem.index = index + 1;
//     structuredItem.function = null; // element that will handle click events
//     // loops through columns and add newitem to structuredItem
//     columns.forEach(colItem => {
//       if (colItem.dataindex) {
//         // populate transform via transformCriteria
//         if(colItem.transformORCriteria){
//             colItem.transform = populateTransformViaCriteria(
//               item,
//               colItem.transformORCriteria,
//               colItem.transformIfTrue,
//               colItem.transformIfFalse,
//             );
//         }
//         // add new key-value to structuredItem
//         structuredItem[colItem.dataindex] = dataTransform(
//           resolve(colItem.dataindex, item),
//           colItem.transform,
//           resolve(colItem.altDataIndex, item)
//         );
//         // add styling to structuredItem
//         // structuredItem[colItem.dataindex] = <div style={colItem.style}>{structuredItem[colItem.dataindex]}</div>
//       }
//     });
//     reStructuredList.push(structuredItem);
//   });
//   // console.log("done restructure");
//   return reStructuredList;
// };

// transform data if needed

// resolve the path in object

window.Clipboard = ((window, document, navigator) => {
  var textArea, copy;

  // function isOS() {
  //   return navigator.userAgent.match(/ipad|iphone/i);
  // }

  function createTextArea(text) {
    textArea = document.createElement("textArea");
    textArea.value = text;
    textArea.setAttribute("readonly", true);
    document.body.appendChild(textArea);
  }

  function selectText() {
    // var range, selection;
    // if (isOS()) {
    //   range = document.createRange();
    //   range.selectNodeContents(textArea);
    //   selection = window.getSelection();
    //   selection.removeAllRanges();
    //   selection.addRange(range);
    //   textArea.setSelectionRange(0, 999999);
    // } else {
    //   textArea.select();
    // }
    textArea.select();
  }

  function copyToClipboard() {
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  copy = text => {
    createTextArea(text);
    selectText();
    copyToClipboard();
  };

  return {
    copy: copy
  };
})(window, document, navigator);

export const dayList = [{ id: 0, name: "Ngày" }];
for (let i = 1; i <= 31; i++) {
  dayList.push({ id: i, name: i });
}

export const monthList = [{ id: 0, name: "Tháng" }];
for (let i = 1; i <= 12; i++) {
  monthList.push({ id: i, name: i });
}

export const yearList = [{ id: 0, name: "Năm" }];
for (let i = new Date().getFullYear(); i >= 1900; i--) {
  yearList.push({ id: i, name: i });
}

// const kyTuDacBiet = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
const regexName = /[~!@#$%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi; // bỏ ký tự  '  (nháy đơn) trong ràng buộc "họ tên Dân tộc"
export const removeNewlines = str => {
  if (!str) {
    return "";
  }
  // str = str.replace(/[\W\s]/g, " ");
  str = str.replace(regexName, "");
  str = str.replace(/\s{2,}/g, " ");
  str = str.replace(/\t/g, " ");
  str = str
    .toString()
    .toUpperCase()
    .trim()
    .replace(/(\r\n|\n|\r)/g, "");
  return str;
};

export const name = str => {
  if (!str) {
    return "";
  }
  str = str.replace(regexName, "");
  str = str.replace(/\s{2,}/g, " ");
  str = str.replace(/\t/g, " ");
  str = str.toString().replace(/(\r\n|\n|\r)/g, "");
  return str;
};

export const validName = value => {
  value = value.replace(regexName, "");
  value = value.replace(/^\s+|\s+$/g, " ");
  value = value.toLowerCase();
  value = value.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  value = value.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  value = value.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  value = value.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  value = value.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  value = value.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  value = value.replace(/đ/g, "d");
  return value;
};

export const validEmail = value => {
  value = value.replace(/^\s+|\s+$/g, " ");
  value = value.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  value = value.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  value = value.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  value = value.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  value = value.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  value = value.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  value = value.replace(/đ/g, "d");
  return value;
};

export const NonUpLive = () => {
  const { hostname } = window.location;
  // thuộc nhóm này thì hiển thị
  if (
    hostname.includes("localhost") ||
    hostname.includes("testing") ||
    hostname.includes("hotfix") ||
    hostname.includes("beta") ||
    hostname.includes("192.168.0.168")
  ) {
    return true;
  }
  // nhóm này là live
  else {
    return false;
  }
};

export const convertDataToMutipleBookings = (
  totalDataReducer,
  globalReducer,
  paymentReducer,
  patientReducer
) => {
  const treeId = get(totalDataReducer, "treeId", "");

  const partnerid = get(totalDataReducer, "partnerId", "");
  const platformType = get(globalReducer, "device.type");
  const bookingInfo = totalDataReducer.schedulesSelected;
  const methodId = get(paymentReducer, "methodId", "NO_PAYMENT");
  const paymentTypeDetail = get(
    paymentReducer,
    "selectedMethod.code",
    "NO_PAYMENT"
  );
  const patientId = get(patientReducer, "selectedPatientId", "");
  const insuranceCode = get(patientReducer, "selectedPatient.insuranceCode");
  const serviceType = get(totalDataReducer, "service.serviceType");
  const insuranceChoice = get(totalDataReducer, "service.insuranceChoice");

  const thongTinBaoHiem = {
    hasInsuranceCode: serviceType === SERVICE_TYPE_INSURANCE,
    insuranceChoice,
    insuranceCode,
    insuranceTransferCode: ""
  };

  // trả về thông tin đặt khám
  return {
    bookings: getDataBooking(bookingInfo, partnerid, treeId),
    platform: platformType === "desktop" ? "pc" : "web",
    methodId,
    paymentTypeDetail,
    patientId,
    ...thongTinBaoHiem,
    patientProfileId: "",
    referralCode: "",
    cbWebView: 0,
    groupId: 1,
    treeId
  };
};

const getDataBooking = (bookingInfo, partnerid, treeId) => {
  return bookingInfo.map(item => {
    const serviceId = get(item, "service.id", "");
    const subjectId = get(item, "subject.id", "");
    const doctorId = get(item, "doctor.id", "");
    const roomId = get(item, "room.id", "");

    // fomart and get value date
    const date = get(item, "date", 0);
    const formatDate = moment(date).format("YYYY-MM-DD");
    // start
    const startTime = get(item, "time.startTime", "");
    const startTimeString =
      moment(formatDate + " " + startTime).toISOString() || "";
    // date string
    const dateString = moment(formatDate + " " + startTime).toISOString() || "";

    // end
    const endTime = get(item, "time.endTime", "");
    const endTimeString =
      moment(formatDate + " " + endTime).toISOString() || "";
    const timeSlotId = get(item, "time.timeId", "");

    const maxSlot = get(item, "time.maxSlot", "");

    // trả về danh sách thông booking
    return {
      serviceId: serviceId,
      subjectId: subjectId,
      roomId: roomId,
      doctorId: doctorId,
      // fomart and get value date
      startTimeString: dateString,
      startTime: startTimeString,
      endTime: endTimeString,
      bookingSlotId: dateString !== "" ? `${timeSlotId}_${partnerid}` : "",
      availableSlot: 1,
      treeId,
      maxSlot
    };
  });
};
export const isEmptyObject = obj => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const getKeyCookie = (key, options) => {
  return Cookies.get(key, options);
};

export const setKeyCookie = (key, value, options = {}) => {
  Cookies.set(key, value, {
    ...options,
    secure: true,
    sameSite: "strict",
    expires: 365
  });
};

export const deleteKeyCookie = (key, options) => {
  Cookies.remove(key, options);
};
